// 供應商資料頁「梯次數量（每小時）」的輸入解析：表單字串 → number | null。純函式，vitest 覆蓋。
export const SLOTS_PER_HOUR_MIN = 1
export const SLOTS_PER_HOUR_MAX = 60
export const SLOTS_PER_HOUR_HINT = `請輸入 ${SLOTS_PER_HOUR_MIN} 到 ${SLOTS_PER_HOUR_MAX} 的整數，或留空表示未設定`

export type SlotsInputResult = { ok: true; value: number | null } | { ok: false; message: string }

export function parseSlotsInput(raw: string | number | null | undefined): SlotsInputResult {
  const text = raw === null || raw === undefined ? '' : String(raw).trim()
  if (text === '') return { ok: true, value: null }
  if (!/^\d+$/.test(text)) return { ok: false, message: SLOTS_PER_HOUR_HINT }
  const n = Number(text)
  if (n < SLOTS_PER_HOUR_MIN || n > SLOTS_PER_HOUR_MAX) return { ok: false, message: SLOTS_PER_HOUR_HINT }
  return { ok: true, value: n }
}

/** 表單初始值：null／undefined → 空字串 */
export function slotsToInput(value: number | null | undefined): string {
  return value === null || value === undefined ? '' : String(value)
}
